import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { Pagination } from "../../core/models/pagination.model";
import { Employee } from "../../core/models/employee.model";

@Component({
    selector: 'app-employee-list',
    templateUrl: './employee-list.component.html',
    styleUrls: ['./employee-list.component.css']
})
export class EmployeeListComponent implements OnInit {

    // Which lot is in use here
    @Input()
    pagination: Pagination;

    @Input()
    verifications: any[];

    employees: Employee[] = [];
    data: Pagination;
    lotId: number;

    loading: boolean;


    constructor(
        private router: Router,
    ) {
    }


    ngOnInit() {

    }

    // Load Next Page when using Pagination
    showPage(page: string) {

        // Set our navigation extras object
        // that contains our global query params and fragment
        const navigationExtras: NavigationExtras = {
            queryParams: {
                page: page
            },
            queryParamsHandling: 'merge'
        };

        // Get the current path
        const currentUrlPath = this.router.url.split('?')[0];

        this.router.navigate([currentUrlPath], navigationExtras);
    }

}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/employee/employee-list/employee-list.component.ts